import React, { Component, StrictMode } from "react";
import {
  Card,
  Container,
  InputGroup,
  Button,
  Tooltip
} from "react-bootstrap";

import Toggle from 'react-toggle';
import "react-toggle/style.css";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
//import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "../../../CSS/AddReceiptStyles.css";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faMinusCircle, faCopy, faEdit, faRe } from '@fortawesome/free-solid-svg-icons';
import { RowNode } from "ag-grid-community";

const divStyle = {
  width: "100%",
  maxHeight: "calc(75vh)",
  margin: "5px",
  //border: '5px solid black'
};


export default class AddReceiptLineGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      columnDefs: this.createColumnDefs(),
      gridData: [],
      selectedRow: null,
      isChecked: true
    }
    this.dataReady = false;

    this.onGridReady = this.onGridReady.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.onRemoveCurrentLineRequest = this.onRemoveCurrentLineRequest.bind(this);
    this.onEditCurrentLineRequest = this.onEditCurrentLineRequest.bind(this);
  }

  componentDidUpdate(prevState, prevProps) {
    console.log("AddReceiptLineGrid Page component has Updated")
    // var thisNode = this.gridApi.getDisplayedRowAtIndex(this.gridApi.getLastDisplayedRow());
    // if (thisNode) {
    //   thisNode.setSelected(true);
    // }
  }

  onSelectionChanged() {
    console.log("Changing selected row to: ")
    var selectedNodes = this.gridApi.getSelectedNodes();
    console.log(selectedNodes)
    var rowData = (selectedNodes[0]) ? selectedNodes[0].data : null;
    //var rowNode = selectedNodes[0];
    //rowNode.setSelected(true);
    //this.refreshRowSelection(rowData);
    // console.log("Selected Row: ");
    // console.log(rowData);

    this.setState({ selectedRow: rowData }); 
    //Setting the state here is apparently dangerous and is causing some kind of desync on the grid
    this.props.updateSelectedReceiptLine(rowData); 
    //Passing it back here w/o setting state also causes this?
  }

  onRemoveCurrentLineRequest() {
    if (!this.state.selectedRow) {
      this.props.onModalAlertShowRequest("Line Delete Error", "Please select a row before attempting to remove it!", "warning");
      //alert ("Please select a row before attempting to remove it!");
      return;
    }
    this.props.onRequestRemoveReceiptLine(this.state.selectedRow.lineId);
  }

  onEditCurrentLineRequest() {
    if (!this.state.selectedRow) {
      this.props.onModalAlertShowRequest("Line Delete Error", "Please select a row before attempting to edit it!", "warning");
      //alert ("Please select a row before attempting to edit it!");
      return;
    }
    this.props.onRequestLineEditEditor();
  }

  refreshGridData() {
    this.setState({
      isLoading: true
    });
    var gridDataResponse = this.props.rowData;
    this.setState({
      gridData: gridDataResponse,
      isLoading: false
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    this.dataReady = true;
    this.gridApi.getDisplayedRowAtIndex(0);

  }

  createColumnDefs() {
    var columnDefs = [
      { headerName: "Line", field: "lineNbr", sort: "asc", sortable: true, filter: false, resizable: true, maxWidth: 20, type: "numericColumn" },
      { headerName: "Item", field: "itemName", sortable: true, filter: true, resizable: true, maxWidth: 220 },
      { headerName: "Pool", field: "poolName", sortable: true, filter: true, resizable: true, maxWidth: 180 },
      { headerName: "Block", field: "blockName", sortable: true, filter: true, resizable: true, maxWidth: 120 },
      { headerName: "Line", field: "tagLineQty", sortable: true, filter: false, resizable: true, maxWidth: 75, type: "numericColumn" },
      { headerName: "Pallet", field: "aggregateLineQty", sortable: false, filter: false, resizable: true, maxWidth: 75, type: "numericColumn" },
      { headerName: "Diff", field: "diffLineQty", sortable: false, filter: false, resizable: true, maxWidth: 75, type: "numericColumn", cellStyle: this.lineDiffStyle }
    ];
    return columnDefs;
  }

  lineDiffStyle(params) {
    // console.log("Line Diff Params: ");
    // console.log(params);
    if (parseInt(params.data.diffLineQty) === 0) {
      return { 'background-color': 'rgba(70, 191, 63, 0.68)' };
    } else if (parseInt(params.data.diffLineQty) < 0) {
      return { 'background-color': 'rgba(235, 25, 25, 0.7)' }
    } else {
      return { 'background-color': 'rgba(235, 231, 25, 0.66)' }
    }
  }

  toggleClicked(e) {
    this.props.toggleCopyLastLineOnAdd(e.currentTarget.checked);
    this.setState({
      isChecked: !this.state.isChecked
    })
  }

  render() {

    if (this.dataReady) {
      console.log(" Lines (this.props.rowData) about to be rendered: ");
      console.log(this.props.rowData);
      this.gridApi.setRowData(this.props.rowData);
      
      if (this.props.requestedLineRowId)
      {
        this.gridApi.getRowNode(this.props.requestedLineRowId).setSelected(true);
        this.props.onSetSelectedLineRequest(null); // turn OFF the programmatic selection selection
      }
      
    }

    return (

      <span>
        <Tooltip/>
        <Card>
          <Card.Header style={{ display: "-webkit-inline-flex", maxHeight: "50px" }}>
            <span style={{ minWidth: "max-content", paddingTop: "0" }}>
              Receipt Lines
            </span>

            <Container fluid style={{ paddingTop: "0" }}>
              <InputGroup size="sm" className="receipt-line-buttons">

                <p data-tip="Add a new Receipt Line">
                  <Button
                    size="sm"
                    variant="outline-info"
                    onClick={this.props.onRequestLineAddEditor}
                  >
                    <FontAwesomeIcon icon={faPlusCircle} />
                    &nbsp;Add
                  </Button>
                </p>
                <p data-tip="Remove currently-selected Receipt Line)">
                  <Button
                    size="sm"
                    variant="outline-info"
                    onClick={this.onRemoveCurrentLineRequest}
                  >
                    <FontAwesomeIcon icon={faMinusCircle} />
                    &nbsp;Remove
                  </Button>
                </p>

                <p data-tip="Edit the currently-selected receipt Line">
                  <Button
                    size="sm"
                    variant="outline-info"
                    onClick={this.onEditCurrentLineRequest}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                    &nbsp;Edit
                  </Button>
                </p>
                <p data-tip="copy the last saved line into a newly added line">
                  &nbsp;&nbsp;
                  <Toggle
                    id='copylastlineonadd-status'
                    size={"sm"}
                    defaultChecked={this.props.copyLastLineOnAdd.toString()}
                    value={this.props.copyLastLineOnAdd}
                    onChange={this.props.onToggleCopyLastLineOnAdd} 
                  />
                  <span>copy last line</span>
                </p>
              </InputGroup>
            </Container>


          </Card.Header>
          <Card.Body style={{ padding: "0" }}>
            <div style={{ width: "100%", height: "100%" }}>
              <Container fluid>
                <div className="ag-theme-balham" style={divStyle}>
                
                  <AgGridReact
                    rowSelection={"single"}
                    // enableRangeSelection={true}
                    flex="true"
                    pagination={false}
                    columnDefs={this.state.columnDefs}
                    // rowData={this.props.rowData}
                    animateRows={true}
                    onGridReady={this.onGridReady}
                    onSelectionChanged={this.onSelectionChanged}
                    domLayout="autoHeight"
                    immutableData={true}
                    getRowNodeId={(data) => data.lineId}
                  />
               
                </div>

              </Container>
            </div>
          </Card.Body>
        </Card>
      </span>
    );
  }
}
